export const formatDiscount = async (discountValue) => {
  let formattedDiscount = discountValue.toString();

  if(formattedDiscount?.includes(",")) {
    formattedDiscount = formattedDiscount.replace(",",".");
  }
  
  return Number(formattedDiscount);
};